module.exports = __webpack_public_path__ + "img/payment.e7eca91f.svg";